import createConverter from 'scripts/application/dto_converters/lib/create_converter';
import SearchResult from 'models/search/search_result';

export default createConverter(SearchResult);
